import { Title } from '@yoast/ui-library';

import { useGetScanQueryResults } from '../../api/generated/insights';
import RouteGuardLoading from '../../components/RouteGuards/RouteGuardLoading';
import QueryCollapsible from './QueryCollapsible';

interface QueryCollapsibleListProps {
  brandId: string;
  analysisId: string;
  scanId: string;
}

const QueryCollapsibleList = ({
  brandId,
  analysisId,
  scanId,
}: QueryCollapsibleListProps) => {
  const { data: queryResultsData, isLoading } = useGetScanQueryResults(
    brandId,
    analysisId,
    scanId,
    {
      query: {
        enabled: !!brandId && !!analysisId && !!scanId,
        select: ({ data }) => data,
      },
    },
  );

  if (isLoading) {
    return <RouteGuardLoading />;
  }

  const queryResults = queryResultsData?.queryResults || [];

  if (queryResults.length === 0) {
    return null;
  }

  return (
    <div className="yst-mt-6">
      <Title size="2" className="yst-mb-4">
        Queries
      </Title>
      {queryResults.map((queryResult) => (
        <QueryCollapsible key={queryResult.id} queryResult={queryResult} />
      ))}
    </div>
  );
};

export default QueryCollapsibleList;
